import {
  IntroDiscoveryUpdate,
  IntroductionDetailResponseDiscoveryUpdates,
} from '@platform/client/schemas';
import { ColumnDef, createColumnHelper } from '@tanstack/react-table';
import { useMemo } from 'react';
import { formatDateStr } from '../../../util/DateHelpers';
import { NoRecordsFoundTabContent, ProfileTabContainer } from '../../components/ProfileComponents';
import { AdminTable } from '../../AdminTable';

const columnHelper = createColumnHelper<IntroDiscoveryUpdate>();

export const DiscoveryUpdatesTabContent = ({
  updatesData,
}: {
  updatesData?: IntroductionDetailResponseDiscoveryUpdates;
}) => {
  const columns = useMemo(() => {
    return [
      columnHelper.accessor('userName', {
        header: 'User',
        cell: (info) => info.getValue(),
      }),
      columnHelper.accessor('userType', {
        header: 'User Type',
        cell: (info) => info.getValue(),
        size: 25,
      }),
      columnHelper.accessor('updateType', {
        header: 'Update Type',
        cell: (info) => info.getValue(),
        size: 25,
      }),
      columnHelper.accessor('notes', {
        header: 'Notes',
        cell: (info) => info.getValue(),
        size: 300,
      }),
      columnHelper.accessor('updateDate', {
        header: 'Date',
        cell: (info) => formatDateStr(new Date(info.getValue())),
        size: 25,
      }),
    ] as ColumnDef<IntroDiscoveryUpdate>[];
  }, []);

  return (
    <ProfileTabContainer>
      {!updatesData || updatesData.length === 0 ?
        <NoRecordsFoundTabContent recordType='introduction' />
      : <AdminTable
          isError={false}
          isLoading={false}
          isSuccess={true}
          columns={columns}
          data={updatesData || []}
          isSimple
          filteredCount={updatesData?.length ?? 0}
        />
      }
    </ProfileTabContainer>
  );
};
